import type { ICoordinates } from '../../../Model/index.js'

export function CoordinatesLabel(props: { coordinates?: ICoordinates }) {
  if (!props.coordinates) return null
  const [lon, lat] = props.coordinates.coordinates
  return (
    <div className="flex flex-col">
      <div>Lat {lat}</div>
      <div>Lon {lon}</div>
    </div>
  )
}
